import React from 'react';
import { useSelector } from 'react-redux';

import ChangePasswordModal from '../../../features/authentication/profile/ChangePasswordModal';
import { selectRequiresPasswordChange } from '../../../features/authentication/redux/selectors';
import { setRequiresPasswordChange } from '../../../features/authentication/redux/slice';
import { useAppDispatch } from '../../../store/hooks';

/**
 * ForcePasswordChangeManager
 *
 * When the backend tells us that the logged-in
 * user must change their password, this component shows the password change
 * screen automatically. The screen has no close or cancel button, the user
 * must set a new password before they can continue using the app.
 *
 * Once the password is changed the backend clears the flag, so the screen
 * will not appear again on the next login.
 */
const ForcePasswordChangeManager = () => {
  const dispatch = useAppDispatch();
  const requiresPasswordChange = useSelector(selectRequiresPasswordChange);

  if (!requiresPasswordChange) {
    return null;
  }

  return (
    <ChangePasswordModal
      forced
      onClose={() => dispatch(setRequiresPasswordChange(false))}
    />
  );
};

export default ForcePasswordChangeManager;
